import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwContext, DwFormControl, DwFormControlInit, DwFormFieldConfig, DwMetaDataService, DwMetaDataServiceToken } from '@devwareapps/devware-cap';
import { DateTimeUtilService } from '../../util/date-time-util.service';

@DwComponent({
  key: 'fitness-duration-display',
  name: 'Duration Display',
  componentType: DwComponentType.formControl,
  isGlobal: true
})
@Component({
  selector: 'app-duration-display-control',
  template: `
  <div>{{ formattedDuration}}</div>
  `
})
export class DurationDisplayControlComponent implements DwFormControl, DwFormControlInit {
  fieldDef: DwFormFieldConfig;
  formGroup: FormGroup;
  context: DwContext;
  useDisplayField?: boolean;

  formattedDuration: string;

  constructor(@Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
    private dateTimeUtilService: DateTimeUtilService
  ) { }

  initControl(): void {

  }

  ngOnInit() {
    this.updateValue();

    this.control.valueChanges.subscribe(value => {
      this.updateValue();
    });
  }

  private updateValue() {
    this.formattedDuration = this.dateTimeUtilService.formatDuration2(this.control.value * 60);
  }

  get control(): AbstractControl {
    return this.formGroup.get(this.fieldDef.attrName);
  }
}
